import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, params) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/marketplace/invite/${id}`, params)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceCustomer/invite.js